<template>
	<el-container>
		<el-header>
			<el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
		</el-header>
		<div style="margin-top: 5px;">
			<el-row>
				<el-col :span="24" v-for="(li,index) in goodslist">
					<div>
						<el-checkbox style="float: left;" @change="handleCheckedChange" :key="li.ischecked" v-model="li.ischecked"></el-checkbox>
						<ul style="float: left;margin: 2px;">
							<li style="width: 100px;height: 100px;">
								<img class="imgsize" :src='"/img"+ li.goods_address' alt="">
							</li>
						</ul>
						<p>{{li.goods_name}}</p>
						<li>
							￥{{li.goods_saleprice}}
							<el-input-number :min='1' size='mini' v-model="li.goods_count" :step="1" @change="countchanged"></el-input-number>
						</li>
						<li>
							<el-button size="mini" type="danger" round @click="LeaveShopCart(li,index)">我不要了</el-button>
						</li>
					</div>
				</el-col>
			</el-row>
		</div>
		<li>
			<span class="spanlabel">总计：</span>
			<span class="spantxt">￥{{sum}}</span>
			<el-button type="primary" round @click="CommitShopOrder()">去结算</el-button>
		</li>
	</el-container>
</template>

<script>
	import member from '../../apifunction/Member.js'
	export default {
		created() {
			this.userent = this.$myglobal.getUserInfo();
			this.GetMyShopCart();
		},
		data() {
			return {
				userent: null,
				goodslist: [],
				checkAll: false,
				nummin: 0,
				sum: 0
			}
		},
		methods: {
			LeaveShopCart(row,index) {
				member.DelShopCart(this.userent.mobile,row.goods_id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							// this.GetMyShopCart();
							this.goodslist.splice(index, 1)
						} else
							this.$message.info(ent.Msg);
					});
			},
			CommitShopOrder() {
				var list = [];
				for (let i = 0; i < this.goodslist.length; i++) {
					if (this.goodslist[i].ischecked)
						list.push(this.goodslist[i]);

				}
				if (list.length < 1) {
					//this.$message.info('请选择');
					return;
				}
				member.CommitShopOrder(JSON.stringify(list))
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							let morderid = ent.Data;
							var data = {
								path: '/PayMOrder',
								query: {
									ent: morderid
								}
							};
							this.$router.push(data)
						} else
							this.$message.info(ent.Msg);
					})
			},
			countchanged() {
				this.sum = 0;
				if (this.goodslist.length < 1)
					return;
				let tempsum = 0;
				for (let i = 0; i < this.goodslist.length; i++) {
					if (this.goodslist[i].ischecked)
						tempsum += this.goodslist[i].goods_saleprice * this.goodslist[i].goods_count;

				}
				this.sum = tempsum;
			},
			handleCheckAllChange() {
				if (this.goodslist.length < 1)
					return;
				for (let i = 0; i < this.goodslist.length; i++) {
					this.goodslist[i].ischecked = this.checkAll;
				}
				this.countchanged();
			},
			handleCheckedChange() {
				this.countchanged();
			},
			GetMyShopCart() {
				this.goodslist = [];
				member.GetMyShopCart(this.userent.mobile)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								let lists = JSON.parse(ent.Data);
								for (let i = 0; i < lists.length; i++) {
									lists[i].ischecked = false;
								}
								this.goodslist = lists;
							}

						} else
							this.$message.info(ent.Msg);
					})
			}
		}
	}
</script>

<style>
</style>
